export default {
  dateRange: {
    format: 'MMMM d, yyyy',
    range: {
      start: new Date(),
      end: new Date()
    },
    max: new Date(),
    min: new Date(1998, 1, 1)
  },
  range: {
    start: new Date(),
    end: new Date()
  },
  title: 'Billing Report'
};
